<template>
  <div class="join">
    <div class="header">
      <div class="container">
        <div class="con">
          <p :class="{one:true,oner:onershow}">{{join.JOIN_ONE}}<span style="margin: 0 5%; color: #31b5ff">{{join.JOIN_SPAN}}</span></p>
          <!-- <p class="two"> -->
            <!-- 河南诚建工程投资担保有限责任公司成立于2006年，注册资金三亿元人民币，是我省成立的首家专业工程担保公司，也是通过省住建厅备案的首家工程担保公司。 -->
          <!-- </p> -->
          <p :class="{two:true,twoer:twoershow}">{{join.JOIN_TWO}}</p>
          <!-- <p class="two"> -->
            <!-- 公司以“诚实守信、服务建设”为宗旨，汇集专业的工程、财务、法律队伍，以经营的专业化和人才的专业化为基础，发挥专业化的服务优势，具备较高的同行业
            竞争优势，已累计为上万个建设工程项目提供工程担保服务。公司立足工程担保，创立“河南诚建”百年基业。 -->
          <!-- </p> -->
          <button class="button" v-on:click="about">{{join.JOIN_BUTTON}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      onershow: false,
      twoershow: false,
      join: []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.join = response.data.JOIN
        // console.log(this.join)
      })
  },
  methods: {
    handleScroll () {
      // console.log(this.currentScroll)
      // this.currentScroll = window.innerHeight
      this.currentScroll = window.pageYOffset
      // console.log(window.pageYOffset, this.currentScroll)
      if (this.currentScroll >= 2100) {
        // console.log(this.currentScroll)
        this.onershow = true
      }
      if (this.currentScroll >= 2200) {
        this.twoershow = true
      }
    },
    about: function (event) {
      window.location.href = '#/join'
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../static/less/less.css');
// @keyframes fadeUp{
//   0% {
//     opacity: 0;
//     transform: translateY(50px)
//   }
//   100% {
//     opacity: 1;
//     transform: none
//   }
// }
// @keyframes fadeLeft{
//   0% {
//     opacity: 0;
//     transform: translateX(-80%)
//   }
//   100% {
//     opacity: 1;
//     transform: none
//   }
// }
@media only screen and (max-width: 767px) {
  .clearfix {
    display: none;
  }
  .one {
    font-size: 20px;
  }
  .two {
    font-size: 14px;
  }
}
@media only screen and (min-width: 767px) and (max-width: 1000px) {
  .one {
    font-size: 26px;
  }
  .two {
    font-size: 18px;
  }
}
@media only screen and (min-width: 1000px) {
  .one {
    font-size: 36px;
  }
  .two {
    font-size: 18px;
  }
}
.company {
  color: #fdfffc;
  float: left;
}
.join {
  display: flex;
  // min-width: 1200px;
  // height: 368px;
  .con {
    background: url(https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/1.f805871.jpg);
    background-size: cover;
    // position: absolute;
    width: 100%;
    padding: 100px 0;
    text-align: center;
    word-break: break-word;
    .oner {
      // opacity: 1 !important;
      visibility: visible;
      animation-name: fadeUp;
      animation-duration: 1s;
      animation-delay:1s;
      animation-fill-mode: both;
    }
    .one {
      // opacity: 0;
      // font-size: 50px;
      padding-top: 30px;
      text-align: center;
      color: #fff;
      // width: 90%;
    }
    .twoer {
      visibility: visible;
      animation-name: fadeLeft;
      animation-duration: 1.2s;
      animation-delay:1.2s;
      animation-fill-mode: both;
    }
    .two {
      padding: 15px 0 50px 0;
      font-size: 16px;
      text-align: center;
      color: #e3e3e3;
    }
    .button {
      background-color: #3B9FF2;
      width: 120px;
      height: 35px;
      margin-top: 10px;
      border: none;
      cursor: pointer;
      color: #fdfffc;
      border: solid 1px #fdfffc;
      border-radius: 3px;
    }
    .button:hover {
      background: #fdfffc;
      color: #3B9FF2;
      transition: all .3s ease-in-out;
    }
  }
}
.header {
  display: block;
  width: 100%;
  .container {
    // position: absolute;
    // margin: 0 10%;
    // z-index: 99;
    // width: 80%;
    width: 100%;
    // max-width: 1200px;
    margin: 0 auto;
  }
}
.nav {
  height: auto;
  position: relative;
  .logo {
    position: relative;
    float: left;
    text-align: center;
    padding-top: 10px;
  }
    // .tel {
    //   float: right;
    //   // width: 50%;
    //   padding-top: 20px;
    //   span {
    //     display: block;
    //   }
  &-row {
    float: right;
    margin: 0 auto;
    padding-top: 30px;
    .float-right {
      float: right;
      padding: 0 10px 0 0;
      font-size: 16px;
    }
    .clearfix {
      margin: 0px;
      li {
        display: inline-block;
        margin: 0 10px;
      }
      .active {
        display: inline-flex;
        text-align: center;
        a {
          color: #fdfffc;
          transition: 0.6s;
          display: block;
          text-align: center;
          position: relative;
        }
        a:hover {
          background-color: #2973c3;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/join.vue